import { api } from "./config";

export async function StoreCustomer(
  name,
  whatsapp,
  province,
  remark = "",
  default_route,
  validflag = true,
  isCOD,
  isDeliveryRequired,
  isForwardRequired,
  isSubCustomer,
  agentId,
  level,
  isSelfOrder,
  deliveryAddresses,
  forwardAddresses,
  groupId
) {
  // console.log(default_route)
  try {
    const response = await api().post("/customer/store", {
      name,
      whatsapp,
      province,
      remark,
      default_route,
      validflag,
      isCOD,
      isDeliveryRequired,
      isForwardRequired,
      isSubCustomer,
      agentId,
      level,
      isSelfOrder,
      deliveryAddresses,
      forwardAddresses,
      groupId,
    });

    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function PatchCustomer(
  _id,
  name,
  whatsapp,
  groupId,
  province,
  validflag,
  remark,
  default_route,
  isCOD,
  isDeliveryRequired,
  isForwardRequired,
  isSubCustomer,
  agentId,
  level,
  isSelfOrder,
  deliveryAddresses,
  forwardAddresses
) {
  try {
    // If called with a single FormData argument
    if (_id instanceof FormData) {
      const response = await api().patch("/customer/patch", _id, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      
      // Handle new backend response format for FormData
      if (response.status === 200 && response.data.success) {
        return {
          status: 200,
          data: response.data.data,
          message: response.data.message,
          success: true
        };
      } else if (!response.data.success) {
        return {
          status: response.status || 400,
          message: response.data.message || "Failed to update customer",
          success: false
        };
      }
      
      return response.data;
    }

    // Otherwise, use the original JSON body
    const response = await api().patch("/customer/patch", {
      _id,
      name,
      whatsapp,
      groupId,
      province,
      validflag,
      remark,
      default_route,
      isCOD,
      isDeliveryRequired,
      isForwardRequired,
      isSubCustomer,
      agentId,
      level,
      isSelfOrder,
      deliveryAddresses,
      forwardAddresses,
    });

    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.error(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function DeleteCustomer(id) {
  try {
    const url = "/customer/delete/" + id;
    console.log(url);
    const response = await api().delete("/customer/delete/" + id);

    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.error(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetCustomersList(
  search = "",
  page = 0,
  pageSize = 20,
  sort = {},
  validflag = true,
  all = false,
  filters = {}
) {
  try {
    const { route, groupId, agentId, isCOD, isSubCustomer } = filters;
    const response = await api().get("/customer/list", {
      params: {
        page,
        pageSize,
        sort: JSON.stringify(sort),
        search,
        validflag,
        all,
        route,
        groupId,
        agentId,
        isCOD,
        isSubCustomer,
      },
    });

    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetAllCustomers() {
  try {
    const response = await api().get("/customer/all");

    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetBulkRecipients({
  groupId = "",
  station = [],
  activityMode = "active",
  activityPeriod = "",
} = {}) {
  try {
    const response = await api().get("/customer/bulk-recipients", {
      params: {
        groupId,
        station: station.join(","),
        activityMode,
        activityPeriod,
      },
    });

    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetCustomerInfo(customerId) {
  try {
    const response = await api().get(`/customer/${customerId}`);

    // Handle standardized response format
    return response.data;
  } catch (error) {
    console.log(error);
    // Return error in standardized format
    return error.response?.data || { success: false, message: "Network error" };
  }
}
